import { EmberRoute } from '../../../../../enums/emberRoute'
import { NavigationMenuUmbrellaId } from '../enums/navigationMenuUmbrellaId'
import { NavigationMenuItem } from '../types/NavigationMenuItem'

export const navigationMenuUmbrellaConfig: NavigationMenuItem<NavigationMenuUmbrellaId>[] = [
  {
    id: NavigationMenuUmbrellaId.Customers,
    iconLeft: 'briefcaseBusiness',
    label: 'navigation.menu.umbrella.label.customers',
    to: EmberRoute.UmbrellaOrganizations,
  },
  {
    id: NavigationMenuUmbrellaId.Users,
    iconLeft: 'userRound',
    label: 'navigation.menu.umbrella.label.users',
    to: EmberRoute.UmbrellaUsers,
  },
  {
    id: NavigationMenuUmbrellaId.Roles,
    iconLeft: 'userLock',
    label: 'navigation.menu.umbrella.label.roles',
    to: EmberRoute.UmbrellaRoles,
  },
  {
    id: NavigationMenuUmbrellaId.Inbox,
    iconLeft: 'mailbox',
    label: 'navigation.menu.umbrella.label.inbox',
    to: EmberRoute.InboxVouchers,
  },
  {
    id: NavigationMenuUmbrellaId.UmbrellaProfile,
    iconLeft: 'userStar',
    label: 'navigation.menu.umbrella.label.umbrella_profile',
    to: EmberRoute.UmbrellaProfile,
  },
  {
    id: NavigationMenuUmbrellaId.UmbrellaSubscriptions,
    iconLeft: 'iteration',
    label: 'navigation.menu.umbrella.label.umbrella_subscriptions',
    to: EmberRoute.UmbrellaSubscriptions,
  },
]
